import { Link } from 'react-router-dom'

import { WarningIcon } from '../Icons'

interface LowBalanceProps {
  balance?: number
}

export default function LowBalance({ balance }: LowBalanceProps) {
  return (
    <div className="hidden lg:flex gap-2">
      <div
        className="text-red-600 flex items-center gap-1"
        data-testid={balance == 0 && 'out-of-minutes-error'}
      >
        <WarningIcon />
        <span
          className="whitespace-nowrap"
          data-testid={
            balance == 0 ? 'out-of-minutes-reminder' : 'low-balance-reminder'
          }
        >
          {balance == 0 ? (
            'Out of minutes!'
          ) : (
            <>Low balance: &nbsp;{balance} min</>
          )}
        </span>
      </div>
      <Link
        to="/pricing"
        className=" bg-green-100 hover:bg-green-200 transition-bg duration-100 text-white px-2 h-[32px] rounded-md flex items-center justify-center"
      >
        <span className="whitespace-nowrap">Buy minutes</span>
      </Link>
    </div>
  )
}
